var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
function padNumber(value) {
    if (isNumber(value)) {
        return ("0" + value).slice(-2);
    }
    else {
        return '';
    }
}
function isNumber(value) {
    return !isNaN(toInteger(value));
}
function toInteger(value) {
    return parseInt("" + value, 10);
}
var NgbDateUsFormatter = /** @class */ (function (_super) {
    __extends(NgbDateUsFormatter, _super);
    function NgbDateUsFormatter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NgbDateUsFormatter.prototype.parse = function (value) {
        var d;
        if (value) {
            var p = value.split('-');
            d = { year: parseInt(p[2], 10), month: parseInt(p[1], 10), day: parseInt(p[0], 10) };
        }
        return d ? d : null;
    };
    NgbDateUsFormatter.prototype.format = function (date) {
        var stringDate = '';
        if (date) {
            stringDate += isNumber(date.month) ? padNumber(date.month) + '-' : '';
            stringDate += isNumber(date.day) ? padNumber(date.day) + '-' : '';
            stringDate += date.year;
        }
        return stringDate;
    };
    return NgbDateUsFormatter;
}(NgbDateParserFormatter));
export { NgbDateUsFormatter };



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/shared/ngb-date-us-formatter.ts.pre-build-optimizer.js